import { graphql } from "../../services/wp.api.service";

const query = `
mutation ValidateMFACode($mfaCode: String!) {
	validateMFACode(input: { mfaCode: $mfaCode }) {
		success
	}
}`

const validateMFACode = (useMutation) => useMutation(
	["validateMFACode"],
	({ mfaCode }) => graphql({
		query,
		variables: {
			mfaCode
		}
	})
);

export default validateMFACode;